//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    submitText: {
      type: String,
      required: true
    },
    successText: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      failed: false,
      success: false,
      loading: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      companyName: '',
      message: '',
      inputClass: '!tw-bg-white'
    }
  },
  methods: {
    async submit () {
      this.success = false
      this.failed = false
      this.loading = true

      try {
        await this.$api.postContactForm({
          country: this.$country.current.countryCode,
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          company_name: this.companyName,
          message: this.message
        })

        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.phone = ''
        this.companyName = ''
        this.message = ''

        this.$gtm.push({
          event: 'submittedContactForm'
        })

        this.$ph.capture('contact_form_submitted')

        this.success = true
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.failed = true
      }

      this.loading = false
    }
  }
}
